import { useCallback } from "react";
import { debounce } from "lodash";
import { useRecoilValue } from "recoil";
import useNativeApp from "../../../../hooks/useNativeApp";
import { userState } from "../../../../recoil/auth";
import { pushRegister } from "../../../../api/push";

const usePushNotification = (latitude: number, longitude: number) => {
  const { sendMessageToNative } = useNativeApp();
  const user = useRecoilValue(userState);

  const registerPushInfo = useCallback(() => {
    sendMessageToNative("getPushInfo", "setPushInfo", {}).then(
      async (res: any) => {
        if (!res || !user) {
          return;
        }

        res.userId = user?.id;
        res.isAllowRequired = res.pushYn;
        res.lat = latitude;
        res.lon = longitude;

        pushRegister(res).then((regRes) => console.log(regRes));
      }
    );
  }, [sendMessageToNative, user, latitude, longitude]);

  const debouncedRegisterPushInfo = useCallback(
    debounce(() => {
      if (latitude !== 37.496486063) {
        registerPushInfo();
      }
    }, 1000),
    [registerPushInfo]
  );

  return {
    registerPushInfo,
    debouncedRegisterPushInfo,
  };
};

export default usePushNotification;
